import { useEffect, useState } from "react";
import { de } from "@ainkauf/core";
import { Wordmark } from "@/components/Wordmark";
import { Willkommensbild } from "@/components/Willkommensbild";
import { signIn } from "@/lib/auth";
import { verfuegbareAnbieter, type Anbieter } from "@/lib/providers";

/** Anmeldung. Zwei Knöpfe, mehr braucht dieser Bildschirm nicht. */
export function LoginScreen({ inviteCode }: { inviteCode?: string }) {
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState<"apple" | "google" | null>(null);

  // Nur zeigen, was die Instanz auch kann. Bis die Antwort da ist, steht hier
  // nichts: Ein Knopf, der in eine Fehlermeldung führt, ist schlimmer als ein
  // Knopf, der einen Moment später erscheint.
  const [anbieter, setAnbieter] = useState<Anbieter | null>(null);
  useEffect(() => {
    void verfuegbareAnbieter().then(setAnbieter);
  }, []);

  async function start(provider: "apple" | "google") {
    setBusy(provider);
    setError(null);
    try {
      await signIn(provider, inviteCode);
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : de.errors.generic);
      setBusy(null);
    }
  }

  return (
    <div className="mx-auto flex min-h-dvh w-full max-w-md flex-col justify-center gap-7 px-5 py-8">
      <div className="auftritt flex flex-col items-center gap-4 text-center">
        <Willkommensbild />
        <h1 className="text-[2.75rem] leading-none">
          <Wordmark />
        </h1>
        <p className="text-lg text-ink-2">{de.app.tagline}</p>
      </div>

      <div className="auftritt karte flex flex-col gap-3 p-4" style={{ ["--takt" as string]: "120ms" }}>
        <p className="text-center text-sm text-ink-2">{anbieter === null ? de.common.loading : de.auth.subtitle}</p>

        {/* Der erste eingeschaltete Weg ist der auffällige. Solange Apple
            nicht eingerichtet ist, ist das Google. */}
        {anbieter?.apple === true && (
          <button
            type="button"
            onClick={() => void start("apple")}
            disabled={busy !== null}
            data-testid="login-apple"
            className="knopf-haupt min-h-[56px] px-4 text-[17px] disabled:opacity-60"
          >
            {de.auth.apple}
          </button>
        )}
        {anbieter?.google === true && (
          <button
            type="button"
            onClick={() => void start("google")}
            disabled={busy !== null}
            data-testid="login-google"
            className={`min-h-[56px] px-4 text-[17px] disabled:opacity-60 ${anbieter.apple ? "knopf-leise" : "knopf-haupt"}`}
          >
            {de.auth.google}
          </button>
        )}
        {anbieter !== null && !anbieter.apple && !anbieter.google && (
          <p role="alert" className="text-center text-sm text-accent">
            {de.auth.noProvider}
          </p>
        )}
        {error !== null && (
          <p role="alert" className="text-sm text-accent">
            {error}
          </p>
        )}
      </div>
    </div>
  );
}
